import { styled } from "@mui/material";
import { colors, fonts } from "@constants/cssVariables";

export const Paragraph = styled("p")({
  font: fonts.bodyMedium,
  color: colors.neutral80,
});
